module.exports = __webpack_public_path__ + "img/95591723013016.67e4f6d0.png";